import script from "./ApplicationDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationDetailModal.vue?vue&type=style&index=0&id=24e96bde&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24e96bde"]])

export default __exports__